import { ContentType } from "@brookbush/database";
import type { GlossaryTerm } from "@brookbush/types";

import Image from "next/image";

import BookmarkButton from "~/components/BookmarkButton";
import ContentDates from "~/components/ContentDates";
import LikeButton from "~/components/LikeButton";
import ShareButton from "~/components/ShareButton";

const GlossaryTermHeader = ({
	glossaryTerm,
}: {
	glossaryTerm: GlossaryTerm;
}) => {
	const { _id, title, slug, description, thumbnail, _createdAt, _updatedAt } =
		glossaryTerm;

	return (
		<header className="flex flex-col gap-6">
			<div className="grid grid-cols-11 gap-5 sm:gap-6">
				<div className="relative col-span-11 mx-auto my-auto h-48 w-full max-w-md overflow-hidden rounded-xl border sm:col-span-4 md:h-48 lg:col-span-3">
					<Image
						fetchPriority="high"
						fill
						quality={80}
						priority
						src={thumbnail?.url || ""}
						alt={`${title} - Glossary Term Illustration`}
						title={`${title} - Glossary Term`}
						className="object-cover"
						sizes="(min-width: 1024px) 450px, (min-width: 640px) 400px, 300px"
						loading="eager"
					/>
				</div>

				<div className="col-span-11 flex flex-col items-center gap-4 text-center sm:col-span-7 sm:h-auto sm:items-start sm:gap-4 sm:text-left lg:col-span-8">
					<h1 className="-mt-1 -mb-2 font-bold text-2xl sm:text-3xl lg:line-clamp-1 lg:text-4xl">
						{title}
					</h1>

					<ContentDates
						createdAt={_createdAt}
						updatedAt={_updatedAt}
						className="justify-center sm:justify-start"
					/>

					<p className="line-clamp-3 text-lg">{description}</p>

					<div className="flex flex-wrap justify-center gap-3 sm:justify-start">
						<ShareButton href={`/glossary/${slug}`} />

						<BookmarkButton
							contentType={ContentType.GLOSSARY}
							contentId={_id}
						/>
						<LikeButton contentType={ContentType.GLOSSARY} contentId={_id} />
					</div>
				</div>
			</div>
		</header>
	);
};

export default GlossaryTermHeader;
